module.exports = __webpack_public_path__ + "static/media/Test60.96b5f927.bmp";